import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

    private _jsonURL = 'assets/data/clientsData.json';

    constructor(private http: HttpClient) { 
    }
  
    public getC3ClientsData(): Observable<any> {
      return this.http.get(this._jsonURL);
    }
  
    ngOnInit() {
    }
}
